import type { RouteObject } from "react-router-dom";
import { AdminPortalLayout } from "@/app/layouts/AdminPortalLayout";

/** One authenticated workflow spans the portal entry and standalone drill-down pages. */
export const adminMessageRoute: RouteObject = {
  path: "admin/messages",
  lazy: async () =>
    (
      await import("@/features/admin-messaging/route")
    ).loadMessageWorkflowRoute(),
  children: [
    {
      // Audience/history use the main portal; deeper pages are siblings, not children of this shell.
      element: <AdminPortalLayout />,
      children: [
        {
          index: true,
          lazy: async () =>
            (
              await import("@/features/admin-messaging/route")
            ).loadMessageEntryRoute(),
        },
      ],
    },
    {
      path: "recipients",
      lazy: async () =>
        (
          await import("@/features/admin-messaging/route")
        ).loadMessageRecipientsRoute(),
    },
    {
      path: "jobs/:jobId",
      lazy: async () =>
        (
          await import("@/features/admin-messaging/route")
        ).loadMessageJobDetailsRoute(),
    },
    {
      path: "compose",
      lazy: async () =>
        (
          await import("@/features/admin-messaging/route")
        ).loadMessageComposeRoute(),
    },
    {
      path: "preview",
      lazy: async () =>
        (
          await import("@/features/admin-messaging/route")
        ).loadMessagePreviewRoute(),
    },
    {
      path: "approval",
      lazy: async () =>
        (
          await import("@/features/admin-messaging/route")
        ).loadMessageApprovalRoute(),
    },
  ],
};
